import gql from 'graphql-tag';

export const GET_EVENTS_AVAILABILITY_FOR_EVENT_GRID = gql`
  query GetEventsAvailabilityForEventGrid(
    $eventSearch: String
    $city: String
    $includeNearbySecondaryCities: Boolean
    $businessOwner: String
    $neighborhood: String
    $date: String
    $numTicketsAvailableForSale: String
    $theme: String
    $tag: String
    $offerId: Int
    $openPositions: String
    $artistIds: String
    $curatorGroup: String
    $roleAvailable: String
    $isStaffedByCurrentUser: Boolean
    $eventIds: [String]
    $excludeSoldOut: Boolean
    $excludePresale: Boolean
    $excludeNonPresale: Boolean
    $isByob: Boolean
    $maxSlotsTaken: Int
    $upcoming: Boolean
    $upcomingOrCurrent: Boolean
    $published: Boolean
    $globallyPromoted: Boolean
    $type: String
    $eventOrganizedAs: String
    $attendeeTicketingFlow: String
    $status: String
    $minRemainingSpaces: Int
    $orderBy: String
    $orderDirection: String
    $page: Int
    $perPage: Int
    $skipPagination: Boolean
  ) {
    events(
      eventSearch: $eventSearch
      city: $city
      includeNearbySecondaryCities: $includeNearbySecondaryCities
      businessOwner: $businessOwner
      neighborhood: $neighborhood
      date: $date
      numTicketsAvailableForSale: $numTicketsAvailableForSale
      theme: $theme
      tag: $tag
      offerId: $offerId
      openPositions: $openPositions
      artistIds: $artistIds
      curatorGroup: $curatorGroup
      roleAvailable: $roleAvailable
      isStaffedByCurrentUser: $isStaffedByCurrentUser
      eventIds: $eventIds
      excludeSoldOut: $excludeSoldOut
      excludePresale: $excludePresale
      excludeNonPresale: $excludeNonPresale
      isByob: $isByob
      maxSlotsTaken: $maxSlotsTaken
      globallyPromoted: $globallyPromoted
      upcoming: $upcoming
      upcomingOrCurrent: $upcomingOrCurrent
      published: $published
      type: $type
      eventOrganizedAs: $eventOrganizedAs
      attendeeTicketingFlow: $attendeeTicketingFlow
      status: $status
      minRemainingSpaces: $minRemainingSpaces
      orderBy: $orderBy
      orderDirection: $orderDirection
      page: $page
      perPage: $perPage
      skipPagination: $skipPagination
    ) {
      events {
        id
      }
      metadata {
        totalRecords
        currentPage
      }
    }
  }
`;

export const GET_EVENTS_FOR_EVENT_GRID = gql`
  query GetEventsForEventGrid(
    $eventSearch: String
    $city: String
    $includeNearbySecondaryCities: Boolean
    $businessOwner: String
    $neighborhood: String
    $date: String
    $numTicketsAvailableForSale: String
    $theme: String
    $tag: String
    $offerId: Int
    $openPositions: String
    $artistIds: String
    $curatorGroup: String
    $roleAvailable: String
    $isStaffedByCurrentUser: Boolean
    $eventIds: [String]
    $excludeSoldOut: Boolean
    $excludePresale: Boolean
    $excludeNonPresale: Boolean
    $isByob: Boolean
    $maxSlotsTaken: Int
    $upcoming: Boolean
    $upcomingOrCurrent: Boolean
    $published: Boolean
    $globallyPromoted: Boolean
    $type: String
    $eventOrganizedAs: String
    $attendeeTicketingFlow: String
    $status: String
    $minRemainingSpaces: Int
    $orderBy: String
    $orderDirection: String
    $page: Int
    $perPage: Int
    $skipPagination: Boolean
  ) {
    events(
      eventSearch: $eventSearch
      city: $city
      includeNearbySecondaryCities: $includeNearbySecondaryCities
      businessOwner: $businessOwner
      neighborhood: $neighborhood
      date: $date
      numTicketsAvailableForSale: $numTicketsAvailableForSale
      theme: $theme
      tag: $tag
      offerId: $offerId
      openPositions: $openPositions
      artistIds: $artistIds
      curatorGroup: $curatorGroup
      roleAvailable: $roleAvailable
      isStaffedByCurrentUser: $isStaffedByCurrentUser
      eventIds: $eventIds
      excludeSoldOut: $excludeSoldOut
      excludePresale: $excludePresale
      excludeNonPresale: $excludeNonPresale
      isByob: $isByob
      maxSlotsTaken: $maxSlotsTaken
      globallyPromoted: $globallyPromoted
      upcoming: $upcoming
      upcomingOrCurrent: $upcomingOrCurrent
      published: $published
      type: $type
      eventOrganizedAs: $eventOrganizedAs
      attendeeTicketingFlow: $attendeeTicketingFlow
      status: $status
      minRemainingSpaces: $minRemainingSpaces
      orderBy: $orderBy
      orderDirection: $orderDirection
      page: $page
      perPage: $perPage
      skipPagination: $skipPagination
    ) {
      events {
        id
        guestsArriveAt
        localStartsAt
        startsAt
        price
        isPurchasable
        isAvailable
        isSoldOut
        cancelled
        city {
          id
          title
          timezone
          cachedSlug
          currencyCode
          country {
            id
            countryCode
            currencyCode
            currencySymbol
          }
        }
        isVenueConfirmed
        neighborhood {
          id
          title
        }
        venue {
          id
          neighborhood {
            id
            title
          }
        }
        eventThemes {
          id
          title
        }
        attendeeFlow
        propertyMap {
          residential {
            id
            key
            name
          }
          commercial {
            id
            key
            name
          }
          byob {
            id
            key
            name
          }
          outdoors {
            id
            key
            name
          }
          petPresent {
            id
            key
            name
          }
        }
        attendee {
          id
          currentState
          visibleToUser
          ticketsCount
        }
        imageUrl
        isVenueConfirmed
        onPresale
      }
      metadata {
        totalRecords
        currentPage
      }
    }
  }
`;

export const EVENT_CARD_EVENT_FIELDS = gql`
  fragment EventCardEventFields on Event {
    id
    attendeeFlow
    guestsArriveAt
    localStartsAt
    startsAt
    endsAt
    isPurchasable
    isAppliable
    cancelled
    isSoldOut
    onPresale
    city {
      id
      title
      timezone
      cachedSlug
      currencyCode
      country {
        id
        currencySymbol
        countryCode
        __typename
      }
      __typename
    }
    neighborhood {
      id
      title
      __typename
    }
    isVenueConfirmed
    venue {
      id
      neighborhood {
        id
        title
        __typename
      }
      venueCategories {
        id
        name
        isVisibleToFans
        __typename
      }
      __typename
    }
    eventThemes {
      id
      title
      __typename
    }
    competition {
      id
      __typename
    }
    propertyMap {
      alcoholForSale {
        id
        key
        name
        __typename
      }
      alcoholNotPermittedOrSold {
        id
        key
        name
        __typename
      }
      byob {
        id
        key
        name
        __typename
      }
      commercial {
        id
        key
        name
        __typename
      }
      residential {
        id
        key
        name
        __typename
      }
      __typename
    }
  }
`;
